"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixCardSizesOnScreenResize = exports.getEmptyCardData = exports.CardContentMapper = void 0;
const bar_chart_1 = __importDefault(require("./cards-types/bar-chart"));
const line_chart_1 = __importDefault(require("./cards-types/line-chart"));
const cards_types_1 = require("./types/cards-types");
const helpers_1 = require("./helpers");
exports.CardContentMapper = {
    [cards_types_1.CardComponentType.BAR]: bar_chart_1.default,
    [cards_types_1.CardComponentType.LINE]: line_chart_1.default,
};
const CardLayoutMapper = {
    [cards_types_1.CardComponentType.BAR]: () => {
        const { innerWidth: width } = window;
        if (width < 1280) {
            return { i: '-1', x: 0, y: 0, w: 1, h: 3, maxH: 4, minH: 3, maxW: 4, minW: 1 };
        }
        return { i: '-1', x: 0, y: 0, w: 3, h: 4, maxH: 6, minH: 4, maxW: 6, minW: 1 };
    },
    [cards_types_1.CardComponentType.LINE]: () => {
        const { innerWidth: width } = window;
        if (width < 1280) {
            return { i: '-1', x: 0, y: 0, w: 2, h: 3, maxH: 4, minH: 3, maxW: 4, minW: 1 };
        }
        return { i: '-1', x: 0, y: 0, w: 3, h: 3, maxH: Infinity, minH: 1, maxW: Infinity, minW: 1 };
    },
};
const getEmptyCardData = (cardType) => {
    const emptyBasicCard = (0, helpers_1.getEmptyCard)(cardType);
    if (CardLayoutMapper[cardType]) {
        emptyBasicCard.position = { ...CardLayoutMapper[cardType](), i: emptyBasicCard.position.i };
    }
    return emptyBasicCard;
};
exports.getEmptyCardData = getEmptyCardData;
const fixCardSizesOnScreenResize = (cardsData) => cardsData.map((cardData) => {
    const newCardData = { ...cardData };
    const getEmptyLayout = CardLayoutMapper[cardData.component.type];
    if (getEmptyLayout) {
        const newLayout = getEmptyLayout();
        newCardData.position.maxH = newLayout.maxH;
        newCardData.position.minH = newLayout.minH;
        newCardData.position.maxW = newLayout.maxW;
        newCardData.position.minW = newLayout.minW;
        if (newCardData.position.w > newLayout.maxW) {
            newCardData.position.w = newLayout.maxW;
        }
        else if (newCardData.position.w < newLayout.minW) {
            newCardData.position.w = newLayout.minW;
        }
        if (newCardData.position.h > newLayout.maxH) {
            newCardData.position.h = newLayout.maxH;
        }
        else if (newCardData.position.h < newLayout.minH) {
            newCardData.position.h = newLayout.minH;
        }
    }
    return newCardData;
});
exports.fixCardSizesOnScreenResize = fixCardSizesOnScreenResize;
//# sourceMappingURL=card-content-mapper.js.map